<template>
  <v-combobox
    :items="config.levels"
    :label="config.label"
    v-model="someModelClone"
    :multiple="config.multiple == true"
    :chips="config.multiple == true"
    :deletable-chips="config.multiple == true"
    v-on:change="changed()"
  >
    <template v-slot:append>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-icon v-on="on">help_outline</v-icon>
        </template>
        <span v-html="config.help"></span>
      </v-tooltip>
    </template>
  </v-combobox>
</template>

<script>
export default {
  name: "soda-combobox",
  props: {
    config: Object,
    someModel: Object | String,
  },
  watch: {
    someModelClone() {
      this.$emit("input", this.someModelClone);
    },
    someModel() {
      this.someModelClone = this.someModel;
    },
  },
  methods: {
    changed() {
      this.$emit("change");
    },
  },
  data() {
    return {
      someModelClone: this.someModel,
    };
  },
};
</script>

<style scoped></style>
